<div class="wrapper">
  @if (data?.equipmentDetails) {
    <app-cle-edit-equipment-form
      [data]="data?.equipmentDetails"
    />
  } @else {
    <app-cle-add-equipment-form />
  }
  <app-actions-section
    [hideAddMenu]="true"
    [hideLocationOption]="true"
    class="actions-section w-[455px]"
  />
</div>
